export const QUESTION_HEADER_MAX_LENGTH = 110;
export const QUESTION_HEADER_MAX_LENGTH_SCALAR = 1.3;
export const EXCLUDE_ID_KEY = 'exclude_ids';
